export default __webpack_public_path__ + "static/media/le_mont8.dbf60e7b.jpg";